import styled from 'styled-components'

import { MenuAccordion } from '../MenuAccordion'
import { MenuAccordionItem } from '../MenuAccordion/styled'
import { MenuAccordionToggle } from '../MenuAccordionToggle'
import MobileMenuEntryLink from '../MobileMenuEntryLink'

export const SubMenuAccordion = styled(MenuAccordion)`
  padding-left: 0.5rem;
  margin-top: 1rem;
  ${MenuAccordionItem} {
    padding: 0;
    margin: 1rem 0 0;
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 1rem;
    }
  }
  & & {
    border-left: 1px solid hsla(0, 0%, 92.5%, 0.25);
    padding-left: 1rem;

    ${MenuAccordionItem}:last-child {
      margin-bottom: 0;
    }
  }
  & & & {
    margin-left: 0.5em;
    margin-bottom: 1rem;
  }
`

export const SubMenuAccordionToggle = styled(MenuAccordionToggle)`
  padding: 0;
  text-transform: none;
  color: ${({ theme }) => theme.colors.grayscale.white};
`

export const SubMenuEntryLink = styled(MobileMenuEntryLink)`
  padding: 0;
  text-transform: none;
  color: ${({ theme }) => theme.colors.grayscale.white};
`
